import { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { StylingContext, useAuthContext } from '../../store/Contexts';
import './Navbar.css';
import {
    ClientOptionEnum,
    LogEventType,
    SecurityAttributes,
    TenantTiers,
    UserType,
} from '../../utils/data/enums';
import { logEvent } from '../../services/loggingService';
import { getClientOptions } from '../../services/clientService';
import { useIndividualHasBenefitAccess } from '../../hooks/useIndividualHasBenefitAccess';
import { ROUTES } from '../../constants/routes';
import { getText } from '../../i18n';
function ClientMenu() {
    const {
        user,
        adminView,
        publicBrand,
        hasSecurityAttribute,
        clientTierMeetsRequirement,
        isSelfRegistrationEnabled,
        menuLabels: individualMenuLabels,
        displayIndividualAssetMenu,
        menuLabelsLoaded,
    } = useAuthContext();
    const { currentStyling } = useContext(StylingContext);

    const toggleDropdown = event => {
        event.currentTarget.lastChild.classList.toggle('bi-chevron-down');
        event.currentTarget.lastChild.classList.toggle('bi-chevron-up');
        var dropdownContent = event.currentTarget.nextElementSibling;
        if (dropdownContent.style.display === 'block') {
            dropdownContent.style.display = 'none';
        } else {
            dropdownContent.style.display = 'block';
        }
    };

    const showIndividualBenefits = useIndividualHasBenefitAccess();
    const [dataPointsEnabled, setDataPointsEnabled] = useState(false);

    const isLimitedUser = user?.jwt?.type === UserType.LimitedUser;

    useEffect(() => {
        async function loadDataPointsEnabled() {
            try {
                const options = await getClientOptions(0, [
                    ClientOptionEnum.DataPointsEnabled,
                ]);
                const option = options.find(
                    item =>
                        item.clientOptionId ===
                        ClientOptionEnum.DataPointsEnabled,
                );
                setDataPointsEnabled(option?.value === 'true');
            } catch (error) {
                console.error(
                    'Could not fetch DataPointsEnabled option:',
                    error,
                );
            }
        }

        if (adminView) {
            loadDataPointsEnabled();
        }
    }, [adminView]);
    const handleNavLinkClick = event => {
        const clickedLinkText =
            event.currentTarget.querySelector('.text').textContent;
        logEvent(
            LogEventType.NavigatedToMenu,
            `Clicked on menu ${clickedLinkText}`,
        );
    };

    return adminView ? (
        <>
            {hasSecurityAttribute([
                SecurityAttributes.IndividualFullAccess,
                SecurityAttributes.IndividualReadOnly,
            ]) && (
                <NavLink
                    onClick={handleNavLinkClick}
                    to={ROUTES.INDIVIDUALS}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <i
                        className={`bi bi-people${currentStyling.navbarIconClass}`}
                    />
                    <div className={`text${currentStyling.navbarTextClass}`}>
                        {getText('msg_a96e829dca13')}
                    </div>
                </NavLink>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.PortalsFullAccess,
                SecurityAttributes.PortalsReadOnly,
                SecurityAttributes.TemplatesFullAccess,
                SecurityAttributes.TemplatesReadOnly,
                SecurityAttributes.PortalActions,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i className={`bi bi-columns-gap`} />
                        <div className={`text`}>
                            {getText('msg_a0c88242e813')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        {hasSecurityAttribute([
                            SecurityAttributes.PortalsFullAccess,
                            SecurityAttributes.PortalsReadOnly,
                        ]) && (
                            <>
                                <NavLink
                                    to={ROUTES.PORTAL_PAGES}
                                    onClick={handleNavLinkClick}
                                    className={({ isActive }) =>
                                        `${currentStyling.navbarLinkClass}${isActive ? ' active' : ''}`
                                    }
                                >
                                    <div
                                        className={`text${currentStyling.navbarTextClass}`}
                                    >
                                        {getText('msg_a1fffaaafb7c')}
                                    </div>
                                </NavLink>
                            </>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.TemplatesFullAccess,
                            SecurityAttributes.TemplatesReadOnly,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.PORTAL_TEMPLATES}
                                activeClassName="active"
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_f25b700ed9f0')}
                                </div>
                            </NavLink>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.PortalActions,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.ACTIONS}
                                className={({ isActive }) =>
                                    `${currentStyling.navbarLinkClass}${isActive ? ' active' : ''}`
                                }
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_c3cd636a585b')}
                                </div>
                            </NavLink>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.PortalsFullAccess,
                            SecurityAttributes.PortalsReadOnly,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.VIEW_LIVE}
                                className={({ isActive }) =>
                                    `${currentStyling.navbarLinkClass}${isActive ? ' active' : ''}`
                                }
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_e1d839835205')}
                                </div>
                            </NavLink>
                        )}
                    </div>
                </>
            )}

            {hasSecurityAttribute([SecurityAttributes.PortalsFullAccess]) && (
                <NavLink
                    onClick={handleNavLinkClick}
                    to={ROUTES.ASSETS}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <i
                        className={`bi bi-book${currentStyling.navbarIconClass}`}
                    />
                    <div className={`text${currentStyling.navbarTextClass}`}>
                        {getText('msg_df2674dbd417')}
                    </div>
                </NavLink>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.NotificationFullAccess,
                SecurityAttributes.NotificationReadOnly,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i className={`bi bi-bell`} />
                        <div className={`text`}>
                            {getText('msg_690476370b42')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.MESSAGES}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_753a22b2eb61')}
                            </div>
                        </NavLink>
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.MESSAGES_HISTORY}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_90ccd6497400')}
                            </div>
                        </NavLink>
                    </div>
                </>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.ReportsAccess,
                SecurityAttributes.AllReportsAccess,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i className="bi bi-bar-chart" />
                        <div className="text">
                            {getText('msg_88bc3fe3dadd')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.REPORTS_LIST}
                            className={({ isActive }) =>
                                `${currentStyling.navbarLinkClass}${isActive ? ' active' : ''}`
                            }
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_a1fffaaafb7c')}
                            </div>
                        </NavLink>
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.REPORTS_HISTORY}
                            className={({ isActive }) =>
                                `${currentStyling.navbarLinkClass}${isActive ? ' active' : ''}`
                            }
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_90ccd6497400')}
                            </div>
                        </NavLink>
                        {hasSecurityAttribute([
                            SecurityAttributes.AllReportsAccess,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.REPORTS_ALL}
                                className={({ isActive }) =>
                                    `${currentStyling.navbarLinkClass}${isActive ? ' active' : ''}`
                                }
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_63574e4a6c7a')}
                                </div>
                            </NavLink>
                        )}
                    </div>
                </>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.ImportsFileImport,
                SecurityAttributes.ImportsAutoImportReadOnly,
                SecurityAttributes.ImportsAutoImport,
                SecurityAttributes.CustomImportsFullAccess,
                SecurityAttributes.CustomImportsReadOnly,
                SecurityAttributes.ImportQueue,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i className={`bi bi-cloud-upload`} />
                        <div className={`text`}>
                            {getText('msg_e42328ac01cd')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        {hasSecurityAttribute([
                            SecurityAttributes.ImportsFileImport,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.NEW_FILE_UPLOAD}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_64385fdbef55')}
                                </div>
                            </NavLink>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.ImportQueue,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.IMPORT_QUEUE}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_201bb20e8ef2')}
                                </div>
                            </NavLink>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.CustomImportsFullAccess,
                            SecurityAttributes.CustomImportsReadOnly,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.CUSTOM_IMPORTS}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_d13718d3a673')}
                                </div>
                            </NavLink>
                        )}
                        {!isSelfRegistrationEnabled &&
                            hasSecurityAttribute([
                                SecurityAttributes.ImportsAutoImport,
                                SecurityAttributes.ImportsAutoImportReadOnly,
                            ]) && (
                                <NavLink
                                    onClick={handleNavLinkClick}
                                    to={ROUTES.AUTO_IMPORTS}
                                    className={`${currentStyling.navbarLinkClass}`}
                                >
                                    <div
                                        className={`text${currentStyling.navbarTextClass}`}
                                    >
                                        {getText('msg_c1dbd7741a1d')}
                                    </div>
                                </NavLink>
                            )}
                    </div>
                </>
            )}

            {hasSecurityAttribute([
                SecurityAttributes.SecurityRolesFullAccess,
                SecurityAttributes.SecurityRolesReadOnly,
                SecurityAttributes.ThemeFullAccess,
                SecurityAttributes.ThemeReadOnly,
                SecurityAttributes.ClientSettingsFullAccess,
                SecurityAttributes.ClientSettingsReadOnly,
                SecurityAttributes.ViewLog,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i className={`bi bi-gear`} />
                        <div className={`text`}>
                            {getText('msg_754164850f38')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        {hasSecurityAttribute([
                            SecurityAttributes.ClientSettingsFullAccess,
                            SecurityAttributes.ClientSettingsReadOnly,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.SETTINGS}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_c7f73bb54d92')}
                                </div>
                            </NavLink>
                        )}
                        {hasSecurityAttribute([
                            SecurityAttributes.SecurityRolesFullAccess,
                            SecurityAttributes.SecurityRolesReadOnly,
                        ]) && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.SECURITY_ROLES}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_2544899993ff')}
                                </div>
                            </NavLink>
                        )}

                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.GROUPS}
                            className={`${currentStyling.navbarLinkClass}`}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_182d37ec74bf')}
                            </div>
                        </NavLink>
                        {hasSecurityAttribute([
                            SecurityAttributes.ThemeFullAccess,
                            SecurityAttributes.ThemeReadOnly,
                        ]) &&
                            publicBrand.enableClientTheme && (
                                <NavLink
                                    onClick={handleNavLinkClick}
                                    to={ROUTES.THEME}
                                    className={`${currentStyling.navbarLinkClass}`}
                                >
                                    <div
                                        className={`text${currentStyling.navbarTextClass}`}
                                    >
                                        {getText('msg_94d5186ba3ec')}
                                    </div>
                                </NavLink>
                            )}
                        {dataPointsEnabled && (
                            <NavLink
                                onClick={handleNavLinkClick}
                                to={ROUTES.DATA_POINTS}
                                className={`${currentStyling.navbarLinkClass}`}
                            >
                                <div
                                    className={`text${currentStyling.navbarTextClass}`}
                                >
                                    {getText('msg_1877c58443d0')}
                                </div>
                            </NavLink>
                        )}
                    </div>
                </>
            )}

            <>
                <button
                    className="dropdown-btn"
                    onClick={event => toggleDropdown(event)}
                >
                    <i className={`bi bi-heart-pulse`} />
                    <div className={`text`}>{getText('msg_927f40673764')}</div>
                    <i className="bi bi-chevron-down dropdown-chevron" />
                </button>
                <div className="dropdown-container">
                    <NavLink
                        onClick={handleNavLinkClick}
                        to={ROUTES.BENEFIT_PLANS}
                        className={`${currentStyling.navbarLinkClass}`}
                    >
                        <div
                            className={`text${currentStyling.navbarTextClass}`}
                        >
                            {getText('msg_b80f31aa5552')}
                        </div>
                    </NavLink>

                    <NavLink
                        onClick={handleNavLinkClick}
                        to={ROUTES.PLAN_YEAR}
                        className={`${currentStyling.navbarLinkClass}`}
                    >
                        <div
                            className={`text${currentStyling.navbarTextClass}`}
                        >
                            {getText('msg_92eb9f10ce7d')}
                        </div>
                    </NavLink>

                    <NavLink
                        onClick={handleNavLinkClick}
                        to={ROUTES.PLAN_TYPES}
                        className={`${currentStyling.navbarLinkClass}`}
                    >
                        <div
                            className={`text${currentStyling.navbarTextClass}`}
                        >
                            {getText('msg_35a092cd8026')}
                        </div>
                    </NavLink>
                    <NavLink
                        onClick={handleNavLinkClick}
                        to={ROUTES.VIEW_BENEFITS}
                        className={`${currentStyling.navbarLinkClass}`}
                    >
                        <div
                            className={`text${currentStyling.navbarTextClass}`}
                        >
                            View Benefits
                        </div>
                    </NavLink>
                </div>
            </>

            <button
                className="dropdown-btn"
                onClick={event => toggleDropdown(event)}
            >
                <i
                    className={`bi bi-question-circle${currentStyling.navbarIconClass}`}
                />
                <div className={`text${currentStyling.navbarTextClass}`}>
                    {getText('msg_87df60de337f')}
                </div>
                <i className="bi bi-chevron-down dropdown-chevron" />
            </button>
            <div className="dropdown-container">
                <NavLink
                    onClick={handleNavLinkClick}
                    to={ROUTES.RESOURCES}
                    className={`${currentStyling.navbarLinkClass}`}
                >
                    <div className={`text${currentStyling.navbarTextClass}`}>
                        {getText('msg_b6fe7f5e7917')}
                    </div>
                </NavLink>
            </div>

            {hasSecurityAttribute([
                SecurityAttributes.OrganizationLevelsFullAccess,
                SecurityAttributes.OrganizationLevelsReadOnly,
            ]) && (
                <>
                    <button
                        className="dropdown-btn"
                        onClick={event => toggleDropdown(event)}
                    >
                        <i className={`bi bi-diagram-3`} />
                        <div className={`text`}>
                            {getText('msg_519255ae1f74')}
                        </div>
                        <i className="bi bi-chevron-down dropdown-chevron" />
                    </button>
                    <div className="dropdown-container">
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.ORG_LEVELS_DEPARTMENTS}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_0c727f1d35cd')}
                            </div>
                        </NavLink>
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.ORG_LEVELS_DIVISIONS}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_3c91054f4689')}
                            </div>
                        </NavLink>
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.ORG_LEVELS_LOCATIONS}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_e59e8f15f760')}
                            </div>
                        </NavLink>
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.ORG_LEVELS_REGIONS}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_039711232507')}
                            </div>
                        </NavLink>
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.ORG_LEVELS_BUSINESS_UNITS}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_d5734818c14c')}
                            </div>
                        </NavLink>
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.ORG_LEVELS_PAY_GROUPS}
                        >
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {getText('msg_369d31346464')}
                            </div>
                        </NavLink>
                    </div>
                </>
            )}

            {clientTierMeetsRequirement(TenantTiers.Bronze) &&
                hasSecurityAttribute([
                    SecurityAttributes.ClientSSOReadOnly,
                    SecurityAttributes.ClientSSOFullAccess,
                ]) && (
                    <NavLink
                        onClick={handleNavLinkClick}
                        to={ROUTES.SSO_LIST}
                        className={`${currentStyling.navbarLinkClass}`}
                    >
                        <i className={`bi bi-key`}></i>
                        <div
                            className={`text${currentStyling.navbarTextClass}`}
                        >
                            {getText('msg_a9f87647033f')}
                        </div>
                    </NavLink>
                )}
        </>
    ) : (
        menuLabelsLoaded && (
            <>
                {!isLimitedUser && (
                    <NavLink
                        onClick={handleNavLinkClick}
                        to={ROUTES.MY_MESSAGES}
                        className={`${currentStyling.navbarLinkClass}`}
                    >
                        <i
                            className={`bi bi-envelope ${currentStyling.navbarIconClass}`}
                        />
                        <div
                            className={`text${currentStyling.navbarTextClass}`}
                        >
                            {individualMenuLabels.messages}
                        </div>
                    </NavLink>
                )}

                {showIndividualBenefits &&
                    !(
                        isLimitedUser &&
                        !hasSecurityAttribute([
                            SecurityAttributes.UserAccessBenefits,
                        ])
                    ) && (
                        <NavLink
                            onClick={handleNavLinkClick}
                            to={ROUTES.MY_BENEFITS}
                            className={`${currentStyling.navbarLinkClass}`}
                        >
                            <i
                                className={`bi bi-heart-pulse${currentStyling.navbarIconClass}`}
                            />
                            <div
                                className={`text${currentStyling.navbarTextClass}`}
                            >
                                {individualMenuLabels.benefits}
                            </div>
                        </NavLink>
                    )}

                {displayIndividualAssetMenu && (
                    <NavLink
                        onClick={handleNavLinkClick}
                        to={ROUTES.MY_ASSETS}
                        className={`${currentStyling.navbarLinkClass}`}
                    >
                        <i
                            className={`bi bi-book${currentStyling.navbarIconClass}`}
                        />
                        <div
                            className={`text${currentStyling.navbarTextClass}`}
                        >
                            {individualMenuLabels.assets}
                        </div>
                    </NavLink>
                )}
            </>
        )
    );
}

export default ClientMenu;
